var e = TypeError,
  r = function r(_r) {
    if (_r > 9007199254740991) throw e("Maximum allowed index exceeded");
    return _r;
  };
export { r as d };